<template>
  <div>
    <page-main
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="mini"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="700px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <dict-options-edit-form
        ref="editForm"
        :scmTemplateCode="editFormDialogOptions.scmTemplateCode"
        :scmCategoryCode="editFormDialogOptions.scmCategoryCode"
        :disabled="editFormDialogOptions.disabled"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="$refs.editForm.save()">{{
          this.$l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import DictOptionsEditForm from '../edit-form/index'
import store from '../../store'
export default {
  components: {
    PageHeader,
    PageMain,
    DictOptionsEditForm
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        keyID: '',
        companyCode: ''
      }
    }
  },
  computed: {
    selected() {
      return store.state.selected
    }
  },
  watch: {
    selected() {
      this.getData()
    }
  },
  methods: {
    getData(form) {
      if (!this.selected || !this.selected.scmCategoryCode) return
      this.loading = true
      this.$api
        .scmInputTemplateListApi({
          scmCategoryCode: this.selected.scmCategoryCode,
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      if (!this.selected || !this.selected.scmCategoryCode) {
        this.$message.warning(
          this.$l('form_label_tip_select_dict') || '请选选择一个大类'
        )
        return
      }
      const types = {
        add: this.$l('tips_add') || '新增',
        edit: this.$l('tips_edit') || '编辑',
        detail: this.$l('tips_view') || '详情'
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        scmTemplateCode: params.scmTemplateCode,
        scmCategoryCode: this.selected.scmCategoryCode
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    }
  }
}
</script>
